import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ita from './it/it.json';
export const defaultNS = 'ita';

export const resources = {
    it: {
        ita
    }
};

i18next.use(initReactI18next).init({
    lng: 'it', // if you're using a language detector, do not define the lng option
    debug: true,
    resources,
    defaultNS,
});
